module.exports = __webpack_public_path__ + "static/media/bg_homepage_22.bcddf110.png";